// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/1be1744daf7a10345087.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c4f42d1b80632627fc5e","135":"7b6f25a21983215e49cb","136":"17d74cb56c4f1b7ffd1b"}[chunkId] + ".chunk.js";
};